<template>
  <div class="Search">
    <div class="Search-inner">
      <slot name="Search-col"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Search',
  data() {
    return {

    }
  }
}
</script>

<style scoped lang="less">
.Search {
  position: sticky;
  top: 120px;
  z-index: 1000;
  width: 1280px;
  height: 110px;
  margin: 140px auto 0 auto;
  background: #e9f0f7;
  border-radius: 0;
  padding: 0 0 0 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .Search-inner {
    width: 1106px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .Search-btn {
    position: absolute;
    height: 48px;
    right: 85px;
    top: 62%;
    transform: translateY(-50%);
  }
}
</style>